import axios from "../../../axios";

export function getCustomOrderList() {
  const response = axios.post(`/products/custom-products/`);
  return response;
}

export function fetchCustomOrderDetails(id: any) {
  const response = axios.get(`products/custom-product/${id}/`);
  return response;
}
